export default __webpack_public_path__ + "locales/fr/SingleSignOn.json?hash=214562a2c551283cec449ddb5f0d5046";